import { useRouter } from "next/router";

const useGetQueryValue = <T extends string>(param: string): T => {
  const { query } = useRouter();
  const value = query[param] || "";
  if (typeof value === "string") {
    return value as T;
  }
  return value[0] as T;
};

export default useGetQueryValue;
